import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref } from 'vue'
import { issueStore } from '@/stores/issue'
import TextEditor from '@/components/TextEditor.vue'
import Uploader from '@/components/Uploader.vue'
import UploadQueue from '@/components/UploadQueue.vue'
import axios from 'axios'
import { notification } from 'ant-design-vue'

interface Comment {
  body:string|null,
  shared:{ client:boolean, solver:boolean },
  media:{ name:string, type:string, url:string, image:string}[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'IssueShowAddCommentCard',
  setup(__props) {

const saving = ref(false)
const comment = ref<Comment>({
  body: null,
  shared: { client: false, solver: true },
  media: []
})

function saveComment () : void {
  saving.value = true

  axios.post(process.env.VUE_APP_API_URL + '/comments/issue/' + issueStore().issue.id, comment.value).then((r) => {
    issueStore().issue.comments = r.data
    clearComment()
    notification.success({
      message: 'Bericht succesvol geplaatst.',
      description: 'Uw bericht is succesvol geplaatst bij servicemelding #' + issueStore().issue.id + '.',
      duration: 5
    })
  }).catch(() => {
    notification.error({
      message: 'Bericht NIET geplaatst.',
      description: 'Er is iets mis gegaan. Probeer het later nog een keer.'
    })
  }).finally(() => {
    saving.value = false
  })
}

function clearComment () : void {
  comment.value = {
    body: null,
    shared: { client: false, solver: true },
    media: []
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: "Bericht toevoegen",
    bordered: false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_row, { style: {"margin-bottom":"8px"} }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(TextEditor, {
                content: comment.value.body,
                onContentChange: _cache[0] || (_cache[0] = ($event: any) => (comment.value.body = $event))
              }, null, 8, ["content"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_row, { style: {"margin-bottom":"16px"} }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_checkbox, {
                checked: comment.value.shared.client,
                "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((comment.value.shared.client) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Delen met contactpersoon")
                ]),
                _: 1
              }, 8, ["checked"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_row, { style: {"margin-bottom":"16px"} }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(Uploader, {
                "max-file-size": 32,
                "upload-button": true,
                base64: true,
                "current-count": comment.value.media.length,
                onNewFileUploaded: _cache[2] || (_cache[2] = ($event: any) => (comment.value.media.push($event)))
              }, null, 8, ["current-count"]),
              (comment.value.media.length)
                ? (_openBlock(), _createBlock(UploadQueue, {
                    key: 0,
                    "media-items": comment.value.media,
                    onFileDeleted: _cache[3] || (_cache[3] = ($event: any) => (comment.value.media.splice($event, 1)))
                  }, null, 8, ["media-items"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_a_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_divider),
          _createVNode(_component_a_button, {
            type: "primary",
            loading: saving.value,
            disabled: !comment.value.body || !comment.value.body.length || saving.value,
            onClick: saveComment
          }, {
            default: _withCtx(() => [
              _createTextVNode("Bericht toevoegen")
            ]),
            _: 1
          }, 8, ["loading", "disabled"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})